import React, { useState, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import './CopyableMailLink.css'

// A plain mailto: link silently does nothing when the visitor has no desktop
// mail client configured (very common for Gmail/Outlook-in-browser users), so
// the click instead opens Gmail's web compose view in a new tab (works for
// anyone regardless of OS mail-client setup) and copies the address to the
// clipboard as a fallback for visitors on a different webmail provider.
const CopyableMailLink = ({ email, children, className, style, subject }) => {
    const { t } = useTranslation();
    const [copied, setCopied] = useState(false);
    const timeoutRef = useRef(null);

    const handleClick = (e) => {
        e.preventDefault();

        const gmailComposeUrl =
            `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(email)}` +
            (subject ? `&su=${encodeURIComponent(subject)}` : '');
        window.open(gmailComposeUrl, '_blank', 'noopener,noreferrer');

        if (navigator.clipboard?.writeText) {
            navigator.clipboard.writeText(email).catch(() => {});
        }
        setCopied(true);
        clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => setCopied(false), 2200);
    };

    return (
        <span className="CopyableMailLink">
            <a href={`mailto:${email}`} className={className} style={style} onClick={handleClick}>
                {children}
            </a>
            <span className={`CopyableMailLink-toast${copied ? ' is-visible' : ''}`} role="status">
                {t('MailCopied')}
            </span>
        </span>
    )
}

export default CopyableMailLink
